import { render, staticRenderFns } from "./questionNair.vue?vue&type=template&id=b200eb84&scoped=true&"
import script from "./questionNair.vue?vue&type=script&lang=js&"
export * from "./questionNair.vue?vue&type=script&lang=js&"
import style0 from "./questionNair.vue?vue&type=style&index=0&id=b200eb84&lang=scss&scoped=true&"
import style1 from "./questionNair.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b200eb84",
  null
  
)

export default component.exports